<main id="topPage" #topPage>
  <router-outlet></router-outlet>
</main>

<footer class="nga-footer">
</footer>

<a id="back-to-top" (click)="scrollToTop()" class="btn btn-light btn-lg back-to-top" role="button"
  *ngIf="!isDevice"><img src="./assets/params/images/home/ic-top.svg" alt="icon scroll top" /></a>